export default "__VITE_ASSET__CwAgdtuj__$_?nuxt_component=async&nuxt_component_name=SvgoCommonNoDataSearchDark&nuxt_component_export=default__"